// extracted by mini-css-extract-plugin
export default {"errorContainer":"Error_errorContainer__ushUo","errorCard":"Error_errorCard__rlIHV","errorTitle":"Error_errorTitle__DNnuQ","errorMessage":"Error_errorMessage__beyEA"};